import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=399c7bce&scoped=true"
import script from "./platforms.vue?vue&type=script&lang=js"
export * from "./platforms.vue?vue&type=script&lang=js"
import style0 from "./platforms.vue?vue&type=style&index=0&id=399c7bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c7bce",
  null
  
)

export default component.exports